module.exports = __webpack_public_path__ + "media/images/covers/foundation/University-of-York-logo-ac8763fb726c1ec6b4d8d1c5946b65bd.svg";